import * as Yup from 'yup';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import React from 'react';

export type TIdentificationStep = {
  name: IdentificationFormStepNames;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  sidebarTitle: string;
  pageTitle: string;
  stepStatus: StepStatus;
};

export enum StepStatus {
  passive = 'passive',
  completed = 'completed',
  disabled = 'disabled',
}

export enum IdentificationFormSteps {
  gettingStarted = 1,
  generalInfo,
  managementStructure,
  financialState,
  purposeOfBusinessRelations,
  documents,
  additionalInformation,
  managersAndRepresentatives,
  relatedCompanies,
  ownershipStructure,
  generalInfoAssetManager,
  documentsAssetManager,
  taxResidencyAdditionalInformation,
}

export enum IdentificationFormStepNames {
  gettingStarted = 'gettingStarted',
  generalInfo = 'generalInfo',
  managementStructure = 'managementStructure',
  financialState = 'financialState',
  purposeOfBusinessRelations = 'purposeOfBusinessRelations',
  documents = 'documents',
  additionalInformation = 'additionalInformation',
  managersAndRepresentatives = 'managersAndRepresentatives',
  relatedCompanies = 'relatedCompanies',
  ownershipStructure = 'ownershipStructure',
  generalInfoAssetManager = 'generalInfoAssetManager',
  documentsAssetManager = 'documentsAssetManager',
  taxResidencyAdditionalInformation = 'taxResidencyAdditionalInformation',
}

export enum TitleIdentificationBanner {
  FirstIdentification = 'Відкриття рахунку для бізнесу online з ідентифікацією',
  SecondaryIdentification = 'Повторна ідентифікація (reKYC) - оновлення даних клієнта',
}

export type ResolveOptions<TContext = unknown> = {
  value?: unknown;
  parent?: unknown;
  context?: TContext;
};

export interface CustomResolveOptions extends ResolveOptions<unknown> {
  from?: { schema: Yup.AnySchema; value: unknown }[];
}

export type TFormAddress = {
  address?: string | null;
  country: TAutocompleteOption | null;
  postalCode?: string | null;
  region?: TAutocompleteOption | null;
  district?: TAutocompleteOption | null;
  city?: TAutocompleteOption | null;
  street?: TAutocompleteOption | null;
  houseNumber?: string | null;
  building?: string | null;
  apartment?: string | null;
  codeAddress?: string | null;
};
export type TAddress = {
  registrationAddress: TFormAddress;
  permanentAddress: TFormAddress;
  coincidences: boolean;
};

export type TPersonalDocument = {
  documentType: TAutocompleteOption | null;
  documentNumber: string | null;
  documentSeries: string | null;
  registryRecord: string | null;
  issueDate: string | null;
  documentExpiryDate: string | null;
  issuingAuthority: string | null;
};

export type TB2FullCheckResponseItem = {
  identificationNumber: string;
  isContragent: boolean;
  isInTL: boolean;
  isInBBL: boolean;
};

export type TLicense = {
  licenseDate: string | null;
  licenseExpiryTerm: string | null;
  licenseName: string;
  licenseNumber: string;
  licenseOrganisationCreate: string;
};

export type TInfoModal = {
  isOpened: boolean;
  isDisabledOutsideClickClose?: boolean;
  title?: string;
  message: string;
  primaryButtonTitle: string;
  secondaryButtonTitle?: string;
  onClose: () => void;
  onSecondaryButtonClick?: (callback?: () => void) => void;
  onPrimaryButtonClick?: (callback?: () => void) => void;
};

export type TAddressField =
  | 'region'
  | 'district'
  | 'city'
  | 'street'
  | 'postalCode'
  | 'houseNumber'
  | 'building'
  | 'apartment'
  | 'codeAddress'
  | 'address';

export type TTrimValues = Record<string, unknown> | Record<string, unknown>[] | string;
